import { IRoute } from "shared/interface/types";
import { hospitalRoutes } from "./hospitalRoute";
import { discountRoutes } from "./discountRoute";
import { cashLessWorkshopRoutes } from "./cashLessWorkshopRoute";

export const serviceFacilityRoutes: IRoute[] = [...discountRoutes, ...hospitalRoutes, ...cashLessWorkshopRoutes];
